export default __webpack_public_path__ + "static/media/play_gray.8f983187.svg";